import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import RichTextEditor from 'Components/UI/RichTextEditor';

export default buildFacetDesignOverride()
  .override({ hint: 'richtext', readonly: false }, {
    _component: () => RichTextEditor,
  }, overrideReadOnly);
